<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none">
  <circle cx="16" cy="16" r="16" fill="#EA5153"/>
  <path fill="#fff" d="m17.466 16 6.23-6.23a1.035 1.035 0 1 0-1.466-1.466L16 14.534l-6.23-6.23A1.036 1.036 0 1 0 8.304 9.77l6.23 6.23-6.23 6.23a1.035 1.035 0 1 0 1.466 1.466l6.23-6.23 6.23 6.23a1.034 1.034 0 0 0 1.466 0 1.035 1.035 0 0 0 0-1.466L17.466 16Z"/>
</svg>
